<template>
  <div>
    <div class="row f-row">
      <div class="col col-12 chart-title-results text-center mb-2">
        DOCUMENTATION STRUCTURE
      </div>
    </div>
    <OrganizationChart :collapsible="true" :value="docStructure">
      <template #person="slotProps">
        <div class="node-header ui-corner-top">
          {{ slotProps.node.data.label }}
        </div>
        <div class="node-content">
          <img
            src="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png"
            width="32"
          />
          <div>{{ slotProps.node.data.name }}</div>
        </div>
      </template>
      <template #default="slotProps">
        <span>{{ slotProps.node.data.label }}</span>
      </template>
    </OrganizationChart>
  </div>
</template>

<script>
import OrganizationChart from "primevue/organizationchart";
import { getUserDocumentationStructure } from "@/_core/data/Documentation";

export default {
  name: "UserMain",
  components: {
    OrganizationChart
  },
  data() {
    return {
      docStructure: null
    };
  },
  created() {
    this.docStructure = getUserDocumentationStructure();
  }
};
</script>

<style scoped></style>
